import { useCountdown } from '../hooks/useCountdown';

const HeroCountdownTimer = ({ targetDate, title = 'Time Remaining' }) => {
  const [days, hours, minutes, seconds] = useCountdown(targetDate);
  const formatTime = (time) => String(time).padStart(2, '0');

  const isExpired = days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0;

  if (process.env.NEXT_PUBLIC_TRAIT_SHUFFLE_REFRESHED == 'true') {
    return (
      <div className='backdrop-blur-sm'>
        <div>
          <div className='text-2xl font-extrabold text-white bg-white/10 rounded-lg p-3 border border-white/10 backdrop-blur-sm max-w-[400px] text-center'>
            Traits have been refreshed!
          </div>
        </div>
      </div>
    );
  }

  if (isExpired) {
    return (
      <div className='backdrop-blur-sm'>
        <div>
          <div className='text-2xl font-extrabold text-white bg-white/10 rounded-lg p-3 border border-white/10 backdrop-blur-sm max-w-[400px] text-center'>
            Shuffle refresh in progress...
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='backdrop-blur-sm'>
      <div className='mb-4'>
        <div className='text-lg font-bold text-primary-500'>{title}</div>
      </div>

      <div className='grid grid-cols-4 gap-3'>
        <div className='text-center'>
          <div className='bg-white/10 rounded-xl p-3 backdrop-blur-sm border border-white/20'>
            <div className='text-3xl font-extrabold text-white leading-none mb-1'>{formatTime(days)}</div>
            <div className='text-sm font-medium text-primary-200 uppercase tracking-wider'>DAYS</div>
          </div>
        </div>

        <div className='text-center'>
          <div className='bg-white/10 rounded-xl p-3 backdrop-blur-sm border border-white/20'>
            <div className='text-3xl font-extrabold text-white leading-none mb-1'>{formatTime(hours)}</div>
            <div className='text-sm font-medium text-primary-200 uppercase tracking-wider'>HRS</div>
          </div>
        </div>

        <div className='text-center'>
          <div className='bg-white/10 rounded-xl p-3 backdrop-blur-sm border border-white/20'>
            <div className='text-3xl font-extrabold text-white leading-none mb-1'>{formatTime(minutes)}</div>
            <div className='text-sm font-medium text-primary-200 uppercase tracking-wider'>MIN</div>
          </div>
        </div>

        <div className='text-center'>
          <div className='bg-white/10 rounded-xl p-3 backdrop-blur-sm border border-white/20'>
            <div className='text-3xl font-extrabold text-white leading-none mb-1'>{formatTime(seconds)}</div>
            <div className='text-sm font-medium text-primary-200 uppercase tracking-wider'>SEC</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroCountdownTimer;
